import { createFileRoute, redirect } from '@tanstack/react-router';

import { PortalLoginPage } from '@/features/portal/portal-login-page';
import { supabase } from '@/lib/supabase';

// Login del Portal Cliente. Vive fuera del shell admin (sin sidebar,
// sin topbar). Cliente entra acá con email + clave provisional / clave
// nueva si recién aceptó la invitación (link de recovery hace que llegue
// con tokens en el URL fragment — Supabase los procesa automáticamente
// gracias a detectSessionInUrl:true).
//
// beforeLoad:
//   - Si ya hay sesión Y es client_portal → redirect /portal/dashboard
//   - Si ya hay sesión Y es staff → redirect /  (admin)
//   - Si no hay sesión → mostrar form de login
export const Route = createFileRoute('/portal/login')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      const role = (data.session.user.app_metadata as { role?: string } | undefined)?.role;
      if (role === 'client_portal') throw redirect({ to: '/portal/dashboard' });
      // Staff con sesión activa: el admin shell se encarga.
      throw redirect({ to: '/' });
    }
  },
  component: PortalLoginPage,
});
